import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";


import Dashboard from "../Dashboard/Dashboard";
import DailyProductionNew from "../DailyProd/RequisitionNew";

import Chat from "../../Chat/Chat";

import Tranporter from "../DailyProd/RequisitionDetails";
import TransportLedger from "../Register/IndentRegister";
import PendingTransport from "../Register/MrirRegister";

const FieldDataS = (fieldProps) => {
  

  
  return (
    <div className={classes["Fields"]}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
     
        <Route path="/transporter-ledger" element={<TransportLedger />} />

        <Route
          path="/pending-for-transporter-invoice"
          element={<PendingTransport />}
        />
     
        <Route path="/order-transport" element={<Tranporter />} />
        <Route path="/transporter-new" element={<DailyProductionNew />} />

     
        <Route path="/transaction/Purchase/Chatbot" element={<Chat />} />
      </Routes>
    </div>
  );
};

export default FieldDataS;
